export class TechSupportForm {
  public userName: string;
  public userEmail: string;
  public message: string;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/tech-support/tech-support-form.ts